// extracted by mini-css-extract-plugin
export var container = "contact-module--container--TSAvz";
export var mail = "contact-module--mail--UhLVp";
export var emphasis = "contact-module--emphasis--cdu6a";
export var social = "contact-module--social--YQ3xu";